"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUMO1UserSelectors = void 0;
const location_1 = require("@/app/shared/constants/scheduler/location");
const reselect_1 = require("reselect");
const selectUserState = (state) => state.SUMO1_user;
const selectIsAuthorized = (0, reselect_1.createSelector)(selectUserState, (user) => user.isAuthorized);
const selectIsLicenseValid = (0, reselect_1.createSelector)(selectUserState, (user) => user.isLicenseValid);
const selectUser = (0, reselect_1.createSelector)(selectUserState, (user) => user.user);
const selectRole = (0, reselect_1.createSelector)(selectUserState, (user) => user.role);
const selectIsFetching = (0, reselect_1.createSelector)(selectUserState, (user) => user.isFetching);
const selectIsFetchingUserData = (0, reselect_1.createSelector)(selectUserState, (user) => user.isFetchingUserData);
const selectIsGoogleAuthorizationCodeFetching = (0, reselect_1.createSelector)(selectUserState, (user) => user.isGoogleAuthorizationCodeFetching);
const selectIsMicrosoftAuthorizationCodeFetching = (0, reselect_1.createSelector)(selectUserState, (user) => user.isMicrosoftAuthorizationCodeFetching);
const selectIsGoogleLoginFetching = (0, reselect_1.createSelector)(selectUserState, (user) => user.isGoogleLoginFetching);
const selectIsMicrosoftLoginFetching = (0, reselect_1.createSelector)(selectUserState, (user) => user.isMicrosoftLoginFetching);
const selectIsPasswordLoginFetching = (0, reselect_1.createSelector)(selectUserState, (user) => user.isPasswordLoginFetching);
const selectIsConnectGoogleContactsFetching = (0, reselect_1.createSelector)(selectUserState, (user) => user.isConnectGoogleContactsFetching);
const selectShouldPromptGoogleContacts = (0, reselect_1.createSelector)(selectUser, (user) => {
    const types = user?.integrations?.map((integration) => integration?.type) ?? [];
    return types.includes(location_1.IntegrationType.GOOGLE_CALENDAR) && !types.includes(location_1.IntegrationType.GOOGLE_CONTACTS);
});
// Login flow selectors
const selectLoginStep = (0, reselect_1.createSelector)(selectUserState, (user) => user.loginStep);
const selectLoginEmail = (0, reselect_1.createSelector)(selectUserState, (user) => user.loginEmail);
const selectLoginEmailError = (0, reselect_1.createSelector)(selectUserState, (user) => user.loginEmailError);
const selectLoginPassword = (0, reselect_1.createSelector)(selectUserState, (user) => user.loginPassword);
const selectLoginPasswordError = (0, reselect_1.createSelector)(selectUserState, (user) => user.loginPasswordError);
// SSO selectors
const selectSsoEmail = (0, reselect_1.createSelector)(selectUserState, (user) => user.ssoEmail);
const selectSsoForm = (0, reselect_1.createSelector)(selectUserState, (user) => user.ssoForm);
const selectSsoEmailError = (0, reselect_1.createSelector)(selectUserState, (user) => user.ssoEmailError);
const selectIsCheckingEmail = (0, reselect_1.createSelector)(selectUserState, (user) => user.isCheckingEmail);
// MFA selectors
const selectMfaError = (0, reselect_1.createSelector)(selectUserState, (user) => user.mfaError);
const selectMfaIsFetching = (0, reselect_1.createSelector)(selectUserState, (user) => user.mfaIsFetching);
exports.SUMO1UserSelectors = {
    selectUserState,
    selectIsAuthorized,
    selectIsLicenseValid,
    selectUser,
    selectRole,
    selectIsFetching,
    selectIsFetchingUserData,
    selectIsGoogleAuthorizationCodeFetching,
    selectIsMicrosoftAuthorizationCodeFetching,
    selectIsGoogleLoginFetching,
    selectIsMicrosoftLoginFetching,
    selectIsPasswordLoginFetching,
    selectIsConnectGoogleContactsFetching,
    selectShouldPromptGoogleContacts,
    // Login flow selectors
    selectLoginStep,
    selectLoginEmail,
    selectLoginEmailError,
    selectLoginPassword,
    selectLoginPasswordError,
    // SSO selectors
    selectSsoEmail,
    selectSsoForm,
    selectSsoEmailError,
    selectIsCheckingEmail,
    // MFA selectors
    selectMfaError,
    selectMfaIsFetching,
};
